<script>
    import imagesLoaded from 'imagesloaded';

    export default {
        name: 'Graph',
        data () {
            return {
                fragments: {
                    children: [],
                    authors: [],
                    main: false,
                    others: []
                },
                lines: [],
                viewBox: '0 0 100 100'
            }
        },
        methods: {
            init() {
                this.fragments.authors = this.$el.querySelectorAll('[data-fragment="authors"]');
                this.fragments.others = this.$el.querySelectorAll('[data-fragment="others"]');
                this.fragments.children = this.$el.querySelectorAll('[data-fragment="children"]');
                this.fragments.main = this.$el.querySelector('[data-fragment="main"] > .fragment');

                this.resizeHandler();
                window.addEventListener('resize', this.resizeHandler);

                let all = [].concat(this.fragments.authors, this.fragments.others, this.fragments.children, this.fragments.main);
                imagesLoaded(all, () => {
                    this.resizeHandler();

                    // This fixes a video element screwing up lines in most cases.
                    // TODO: find a "loaded" event for <video> elements
                    setTimeout(() => {
                        this.resizeHandler();
                    }, 2000);
                    setTimeout(() => {
                        this.resizeHandler();
                    }, 2000);
                });
            },
            resizeHandler() {
                requestAnimationFrame(() => {
                    this.lines = this.getLines();
                    this.setMinHeight();
                    this.viewBox = this.getViewBox();
                });
            },
            setMinHeight() {
                let childrenOffset = this.getPointFromElement(this.$refs.children, { anchor: 'bottom-left'});
                let parentsOffset = this.getPointFromElement(this.$refs.parents, { anchor: 'bottom-left'});
                let othersOffset = this.getPointFromElement(this.$refs.others, { anchor: 'bottom-left'});
                let svgOffset = this.getPointFromElement(this.$refs.svg, { anchor: 'top-left'});

                let minHeight = 0;

                if (childrenOffset._height > minHeight) minHeight = childrenOffset._height;
                if (parentsOffset._height > minHeight) minHeight = parentsOffset._height;
                if (othersOffset._height > minHeight) minHeight = othersOffset._height;

                this.$refs.svg.style.minHeight = minHeight + 'px';
            },
            getLines() {
                let lines = [];
                let DISTANCE = 10;
                if (window.innerWidth > 400) DISTANCE = 15;
                if (window.innerWidth > 700) DISTANCE = 30;
                if (window.innerWidth > 900) DISTANCE = 40;

                if (this.fragments.main) {

                    // Draw lines to the left
                    let shouldDrawLeftDock = this.fragments.authors.length > 1;
                    let mainLeft = this.getPointFromElement(this.fragments.main, { anchor: 'left-middle'});
                    let mainLeftDock = { ...mainLeft, x: mainLeft.x - (shouldDrawLeftDock ? DISTANCE : 0) };

                    if (this.fragments.authors.length > 0) {
                        if (shouldDrawLeftDock) lines.push({ x1: mainLeftDock.x, x2: mainLeft.x, y1: mainLeftDock.y, y2: mainLeft.y })
                        for (let i = 0; i < this.fragments.authors.length; i++) {;
                            let elDock = this.getPointFromElement(this.fragments.authors[i], { anchor: 'right-middle' });
                            lines.push({ x1: elDock.x, y1: elDock.y, x2: mainLeftDock.x, y2: mainLeftDock.y });
                        }
                    }

                    // Draw lines to the right
                    let shouldDrawRightDock = this.fragments.others.length > 1;
                    let mainRight = this.getPointFromElement(this.fragments.main, { anchor: 'right-middle'});
                    let mainRightDock = { ...mainRight, x: mainRight.x + (shouldDrawRightDock ? DISTANCE : 0) };

                    if (this.fragments.others.length > 0) {
                        if (shouldDrawRightDock) lines.push({ x1: mainRightDock.x, x2: mainRight.x, y1: mainRightDock.y, y2: mainRight.y })
                        for (let i = 0; i < this.fragments.others.length; i++) {;
                            let elDock = this.getPointFromElement(this.fragments.others[i], { anchor: 'left-middle' });
                            lines.push({ x1: elDock.x, y1: elDock.y, x2: mainRightDock.x, y2: mainRightDock.y });
                        }
                    }

                    // Draw lines to the children (bottom)
                    if (this.fragments.children.length > 0) {
                        let shouldDrawKnick = false; // this.fragments.children.length > 1;

                        let firstChildLeft = this.getPointFromElement(this.fragments.children[0], { anchor: 'left-middle' });
                        let mainBottom = this.getPointFromElement(this.fragments.main, { anchor: 'bottom-left'});

                        mainBottom = { ...mainBottom, x: mainBottom.x + Math.floor((firstChildLeft.x - mainBottom.x) * (1 - 0.618 /* golden ratio */)) };

                        let mainBottomKnick = { ...mainBottom, y: firstChildLeft.y + firstChildLeft._height / 8 * (shouldDrawKnick ? 1 : -1) };
                        let mainBottomDock = { ...mainBottomKnick, x: mainBottom.x + (shouldDrawKnick ? DISTANCE : 0) };

                        lines.push({ x1: mainBottomKnick.x, x2: mainBottom.x, y1: mainBottomKnick.y, y2: mainBottom.y })
                        if (shouldDrawKnick) lines.push({ x1: mainBottomDock.x, x2: mainBottomKnick.x, y1: mainBottomDock.y, y2: mainBottomKnick.y });

                        for (let i = 0; i < this.fragments.children.length; i++) {;
                            let elDock = this.getPointFromElement(this.fragments.children[i], { anchor: 'left-middle' });
                            lines.push({ x1: elDock.x, y1: elDock.y, x2: mainBottomDock.x, y2: mainBottomDock.y });
                        }
                    }
                }

                return lines;
            },
            getViewBox() {
                return '0 0 ' + this.$el.offsetWidth + ' ' + this.$el.scrollHeight;
            },
            getPointFromElement(el, offset) {
                offset = { x: 0, y: 0, anchor: 'top-left', ...offset };

                let rect = el.getBoundingClientRect(),
                    computedStyle = getComputedStyle(el, null);

                let x = 0, y = 0,
                    elWidth = parseFloat(computedStyle.width.replace("px", "")),
                    elHeight = parseFloat(computedStyle.height.replace("px", "")),
                    elOffset = {
                        top: rect.top + document.body.scrollTop - this.$el.getBoundingClientRect().top,
                        left: rect.left + document.body.scrollLeft - this.$el.getBoundingClientRect().left
                    };

                switch (offset.anchor) {
                    case 'top-right':
                        x = elOffset.left + elWidth + offset.x;
                        y = elOffset.top + offset.y;
                        break;
                    case 'top-middle':
                        x = elOffset.left + elWidth / 2 + offset.x;
                        y = elOffset.top + offset.y;
                        break;
                    case 'bottom-middle':
                        x = elOffset.left + elWidth / 2 + offset.x;
                        y = elOffset.top + elHeight + offset.y;
                        break;
                    case 'bottom-left':
                        x = elOffset.left + offset.x;
                        y = elOffset.top + elHeight + offset.y;
                        break;
                    case 'bottom-right':
                        x = elOffset.left + elWidth + offset.x;
                        y = elOffset.top + elHeight + offset.y;
                        break;
                    case 'left-middle':
                        x = elOffset.left + offset.x;
                        y = elOffset.top + elHeight / 2 + offset.y;
                        break;
                    case 'right-middle':
                        x = elOffset.left + elWidth + offset.x;
                        y = elOffset.top + elHeight / 2 + offset.y;
                        break;
                    default:
                        x = elOffset.left + offset.x;
                        y = elOffset.top + offset.y;
                        break;
                    }

                return {
                    x: x,
                    y: y,
                    element: el,
                    _width: elWidth,
                    _height: elHeight,
                    _offset: elOffset
                };
            },
        },
        mounted() {
            this.init();

        },
        beforeDestroy () {
            window.removeEventListener('resize', this.resizeHandler, false);
        }
    };
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/Graph.vue